import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { BillingModel } from './billing.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/billing';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private readonly http = inject(HttpClient);
  billingList: BillingModel[] = [];

  async addData(billing: BillingModel): Promise<BillingModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<BillingModel>>(environment.apiUrl + LIST_ENDPOINT, billing)
    );

    return response.data;
  }

  async loadData(uid: string): Promise<BillingModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<BillingModel>>(environment.apiUrl + `${LIST_ENDPOINT}/${uid}`)
    );

    return response.data;
  }

  async pdf(uid: string): Promise<Blob> {
    const response = await firstValueFrom(
      this.http.get(environment.apiUrl + `/billingpdf/${uid}`, {
        responseType: 'blob',
      })
    );

    return new Blob([response], { type: 'application/pdf' });
  }

  async getList(): Promise<BillingModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<BillingModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    );

    return response.data;
  }
}